import { render, staticRenderFns } from "./LayoutBottom.vue?vue&type=template&id=ecd164ba&scoped=true&"
var script = {}
import style0 from "./LayoutBottom.vue?vue&type=style&index=0&id=ecd164ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd164ba",
  null
  
)

export default component.exports